import { useContext, useEffect, useState } from 'react';
import './mobileOverlay.scss';
import { OpenMenuContext } from '../../entities/toggleMenuContext';
import { NavLink } from 'react-router-dom';
import { LinkInterface } from '../../types/types';
import { profileData } from '../../data/data';
import Logo from '../Logo/Logo';

interface HeaderProps {
   links: LinkInterface[]
}

function MobileOverlay({ links }: HeaderProps) {
   const { isOpen, setIsOpen } = useContext(OpenMenuContext);
   const [width, setWidth] = useState(window.innerWidth);
   const mobileOverlay = isOpen ? 'mobile__overlay-active' : '';

   useEffect(() => {
      const handleResize = () => {
         setWidth(window.innerWidth);
         if (window.innerWidth > 768) {
            setIsOpen(false);
         }
      };

      window.addEventListener('resize', handleResize);

      return () => {
         window.removeEventListener('resize', handleResize);
      };
   }, [width, setIsOpen]);


   return (
      <div className={`mobile__overlay ${mobileOverlay}`} id="mobileOverlay" onClick={() => setIsOpen(!isOpen)}>

         <Logo name={profileData.name} mobile={true} />
         <ul className="mobile__list">
            {links.map(link => (
               <li key={link.id} className="mobile__item">
                  <NavLink to={link.url} className="mobile__link">{link.name}</NavLink>
               </li>
            ))}
         </ul>

      </div>
   )
}

export default MobileOverlay